import { FC } from "react";
import { img } from "../../assets/icon";
import { Desktop } from "../Container/Desktop";
import { Mobile } from "../Container/Mobile";
import {
  BoxPhoto,
  FlexBox,
  LabelPhoto,
  Photo,
  TextPhoto,
  ThumbaPhoto,
  TitlePhoto,
} from "./ManagerItem.styled";
import { getStyleFromTextConfig } from "../../utils/style";

type Props = {
  image?: string;
  title: string;
  config: any;
};

export const ManagerItem: FC<Props> = ({ image, title, config }) => {
  return (
    <BoxPhoto>
      <ThumbaPhoto>
        <Photo src={image ? image : img} alt="photo_manedger" />
      </ThumbaPhoto>
      <Mobile>
        <FlexBox>
          <TitlePhoto>{title}</TitlePhoto>
          <TextPhoto style={getStyleFromTextConfig(config.descriptionConfig)}>
            {config.description}
          </TextPhoto>
        </FlexBox>
      </Mobile>
      <Desktop>
        <>
          <FlexBox>
            <TitlePhoto>{title}</TitlePhoto>
            <LabelPhoto>{config.jobTitle}</LabelPhoto>
          </FlexBox>
          {config.description && <TextPhoto style={getStyleFromTextConfig(config.descriptionConfig)}>{config.description}</TextPhoto>}
        </>
      </Desktop>
    </BoxPhoto>
  );
};
